module.exports = __webpack_public_path__ + "img/13_mark_h.c451b58e.png";